import React, { ReactNode } from "react";
import LeaderboardAdSlot from "../Adverts/LeaderboardAdSlot";

type Props = {
  children?: ReactNode;
};

export const OneColumnContainer = ({ children }: Props) => {
  return (
    <>
      <div className="pt-2">
        <LeaderboardAdSlot />
      </div>
      <div
        className={`container mx-auto grid grid-cols-1 cols-auto gap-x-2 gap-y-2 pt-2 pl-2 pr-2 pb-2 overflow-y:visible`}
      >
        {children}
      </div>
    </>
  );
};
